import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AgentProvider } from './contexts/AgentContext';
import { IntegrationsProvider } from './contexts/IntegrationsContext';
import './assets/css/App.css';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <AgentProvider>
        <IntegrationsProvider>
          <App />
        </IntegrationsProvider>
      </AgentProvider>
    </AuthProvider>
  </BrowserRouter>,
);
